import * as $ from 'jquery';
import './carousel-universal.less';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ResizeService } from '../../page-services/resize-service';

export class CarouselUniversalCommon {

    public static subscribeResize(callback) {
        ResizeService.subscribeStream(callback);
    }

    public static carouselOptions = {
        infinite: true,
        speed: 300,
        draggable: false,
        // slidesToShow: 5,
        slidesToScroll: 1,
        autoPlay: true,
        centerMode: false,
        variableWidth: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    // slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 960,
                settings: {
                    // slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    // slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    }
    public static carouselOptionsV2 = {
        infinite: false,
        speed: 300,
        draggable: false,
        // slidesToShow: 5,
        slidesToScroll: 1,
        autoPlay: true,
        centerMode: false,
        variableWidth: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    // slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 960,
                settings: {
                    // slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    // slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    }
    public static carouselOptionsEditor = {
        infinite: false,
        speed: 300,
        draggable: false,
        // slidesToShow: 5,
        slidesToScroll: 1,
        autoPlay: true,
        centerMode: false,
        variableWidth: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    // slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 960,
                settings: {
                    // slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    // slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    }
    // public static carouselOptions = {
    //     infinite: true,
    //     speed: 300,
    //     draggable: false,
    //     slidesToShow: 3,
    //     autoPlay: true,
    //     centerMode: false,
    //     rows: 0,
    //     variableWidth: true
    // }
    //
    // public static variableWidthCarouselOptions = {
    //     infinite: true,
    //     speed: 300,
    //     draggable: false,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     autoPlay: true,
    //     centerMode: false,
    //     variableWidth: true,
    //     rows: 0
    // }

    private static styleBreakpoint = 960;

    private static unSlick(carousel) {
        try {
            carousel.slick('unslick');
        }
        catch (e) { }
    }

    private static isSlicked(carousel) {
        return carousel.find('.slick-list').length > 0;
    }

    private itemsCount;
    private itemsVisible;

    private static createSlick(carousel, itemsPerPage) {

        let width = carousel.parent().width();
        if (width < 1) return; //invisible


        CarouselUniversalCommon.unSlick(carousel);
        if (CarouselUniversalCommon.needsVariableWidth(carousel, itemsPerPage)) {
            // let sumWidth = 0;
            // carousel.find('.carousel-item').each((idx, el) => {
            //     let item = $(el);
            //     let width = item.find('[data-uid]').eq(0).width();
            //     if (width == undefined || width == 0) width = 250;
            //     item.width(width).css('max-width', width);
            //     if (!item.hasClass('.slick-cloned'))
            //         sumWidth += width;
            // });
            let items = $('.carousel-universal-item');

            let component = carousel.closest('.carousel-universal-component');


            component.css('padding', '0 120px');

            //CarouselCommon.setSlidesToShow(carousel);
            let editors = $('.dom-editor');
            let styleV2 = $('.style-v2');


            // CarouselUniversalCommon.setArrows(carousel, component);
            let isSetArr = CarouselUniversalCommon.isSetArrow(carousel);

            if (isSetArr) {
                component.find('.slick-arrow').show();
            } else {
                component.find('.slick-arrow').hide();
            }

            if (editors.length > 0) {
                // console.log(editors.length , isSetArr);
                carousel.slick({ ...(CarouselUniversalCommon.carouselOptionsEditor) });
            } else if (editors.length == 0 && !isSetArr) {
                // console.log(editors.length , isSetArr);
                carousel.slick({ ...(CarouselUniversalCommon.carouselOptionsEditor) });
                component.find('.slick-arrow').hide();
            } else {
                // console.log(editors.length , isSetArr);
                if (styleV2.length > 0) {
                    carousel.slick({ ...(CarouselUniversalCommon.carouselOptionsV2) });
                } else {
                    carousel.slick({ ...(CarouselUniversalCommon.carouselOptions) });
                }
            }

            carousel.attr('data-variable-width', true);
        }
        else {
            carousel.slick({
                ...(CarouselUniversalCommon.carouselOptions),
                slidesToShow: itemsPerPage
            });
            carousel.removeAttr('data-variable-width');
        }

        carousel.on('afterChange', function (event, slick, currentSlide) {
            //console.log('afterChange', currentSlide);
        });
        $('.carousel-universal-item').animate({ opacity: 1 }, 400);
        CarouselUniversalCommon.setCarouselStyle(carousel, width);
    }

    private static needsVariableWidth(carousel, itemsPerPage) {
        //console.log(carousel.parent().width(), carousel.parent().width() < CarouselUniversalCommon.styleBreakpoint)
        return (itemsPerPage == 100 || carousel.parent().width() < CarouselUniversalCommon.styleBreakpoint);
    }



    private static getSmallestSlideWidth(carousel) {
        let min = 100000;
        carousel.find('.carousel-universal-item').each((i, slide) => {
            let width = $(slide).width();
            if (width < min) {
                min = width;
            }
        })
        return min;
    }

    private static setSlidesToShow(carousel) {
        let slidesToShow = Math.floor(carousel.width() / CarouselUniversalCommon.getSmallestSlideWidth(carousel));
        carousel.slick('slickSetOption', 'slidesToShow', slidesToShow, false).slick('slickSetOption', 'variableWidth', true, true);
        carousel.attr('data-variable-width', true);
    }


    // public static updateSlick(carousel, itemsPerPage) {
    //     carousel.slick('unslick');
    //     return CarouselCommon.createSlick(carousel, itemsPerPage);
    // let width = carousel.parent().width();
    // if (width < 1) return;  //invisible
    // carousel.fadeOut();
    // if (CarouselCommon.needsVariableWidth(carousel, itemsPerPage) && !carousel.attr('data-variable-width')) {
    //     let slidesToShow = Math.floor(carousel.width() / CarouselCommon.getSmallestSlideWidth(carousel));
    //     carousel.slick('slickSetOption', 'slidesToShow', 1, false).slick('slickSetOption', 'variableWidth', true, true);
    //     carousel.attr('data-variable-width', true);
    // }
    // if (!CarouselCommon.needsVariableWidth(carousel, itemsPerPage) && carousel.attr('data-variable-width')) {
    //     carousel.slick('slickSetOption', 'slidesToShow', itemsPerPage, false).slick('slickSetOption', 'variableWidth', false, true);
    //     carousel.removeAttr('data-variable-width');
    // }
    // setTimeout(() => {
    //     CarouselCommon.setCarouselStyle(carousel, width);
    //     carousel.fadeIn();
    // }, 500);

    //}

    private static setCarouselStyle(carousel, width) {

        if (width < CarouselUniversalCommon.styleBreakpoint)
            carousel.parent().addClass('small-carousel');
        else
            carousel.parent().removeClass('small-carousel');
        carousel.find('.carousel-universal-item').css({ maxWidth: `${carousel.width()}px` });
        carousel.slick('setPosition');
    }



    public static initSlick(carousel, itemsPerPage, reCreate = false) {
        //itemsPerPage = CarouselUniversalCommon.getItemPerPage();
        //if (!CarouselCommon.isSlicked(carousel) || reCreate) {
        CarouselUniversalCommon.createSlick(carousel, itemsPerPage);
        // }
        // else {
        //     CarouselCommon.updateSlick(carousel, itemsPerPage)
        // }
    }

    public static equalHeight(carousel) {
        carousel.find('.slick-slide').height(carousel.find('.slick-track').height());
    }

    public static disableSlickDrag() {
        $('*[draggable!=true]', '.slick-track' as any).unbind('dragstart');
    }

    public static setArrows(carousel, component) {
        let items = $('.carousel-universal-item');
        let sum = 0;
        for (let i = 0; i < items.length; i++) {
            sum += items[i].clientWidth;
        }

        if (sum < carousel.parent().width()) {
            component.find('.slick-arrow').hide();
            //component.find('.slick-arrow').show();
        } else {
            component.find('.slick-arrow').show();
        }
    }
    public static isSetArrow(carousel) {
        let items = $('.carousel-universal-item');
        let sum = 0;
        for (let i = 0; i < items.length; i++) {
            sum += items[i].clientWidth + 10;
        }

        // console.log(sum, carousel.parent().width());
        if (sum < carousel.parent().width()) {
            // console.log(false);
            return false;
        } else {
            // console.log(true);
            return true;
        }

    }
}
